export default {
	apiKey: 'AIzaSyBcv7sU-C7Qlgt76IMbMQCNn6oQhdkTW6c',
	authDomain: 'ciosystem.firebaseapp.com',
	databaseURL: 'https://ciosystem.firebaseio.com',
	projectId: 'ciosystem',
	storageBucket: '',
	messagingSenderId: '110179811261',
	appId: '1:110179811261:web:8b4c411f85ce79160f1cd4'
};
